(function(){var se="youngle:quiz-result",ke="youngle:add-to-cart",ce="youngle:add-to-cart-result",Ee=1e4,le=0,Pe=class extends Error{constructor(e){super(e),this.name="AddToCartTimeoutError"}};function Ae(e){const t=r=>{e(r.detail)};document.addEventListener(se,t);const n=window.YoungleQuizResult;return n!==void 0&&e(n),()=>{document.removeEventListener(se,t)}}function de(e,t=Ee){const n=Ie();return new Promise((r,a)=>{let s=!1,i=null;const o=()=>{s=!0,document.removeEventListener(ce,c),i!==null&&(clearTimeout(i),i=null)},c=l=>{var u;const f=l.detail;if(f.requestId===n&&!s){if(o(),f.ok){var p,y;r({requestedLineCount:(p=f.requestedLineCount)!==null&&p!==void 0?p:0,successfulLineCount:(y=f.successfulLineCount)!==null&&y!==void 0?y:0});return}a(new Error((u=f.error)!==null&&u!==void 0?u:"Add-to-cart request failed"))}};document.addEventListener(ce,c),i=setTimeout(()=>{s||(o(),a(new Pe(`Add-to-cart request "${e.source}" did not settle within ${t}ms`)))},t);const d={...e,requestId:n};document.dispatchEvent(new CustomEvent(ke,{detail:d}))})}function Ie(){return le+=1,`yqr-shim-${Date.now()}-${le}`}function Q(e){return{raw:e}}var ne="data-html-placeholder";function ue(e){return e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function Me(e){return typeof e=="object"&&e!==null&&"raw"in e&&typeof e.raw=="string"}function Re(e){if(e==null||e===!1)return"";if(e===!0)return"true";if(typeof e=="string")return ue(e);if(typeof e=="number")return ue(String(e));if(Me(e))return e.raw;if(e instanceof Node)return e;if(Array.isArray(e)){if(e.every(t=>t instanceof Node)){const t=document.createDocumentFragment();for(const n of e)t.appendChild(n);return t}throw new TypeError("html: arrays of non-Node values are not supported")}throw typeof e=="function"?new TypeError("html: functions are not supported as interpolated values"):new TypeError(`html: unsupported interpolated value of type ${typeof e}`)}function m(e,...t){const n=new Map;let r="";for(let o=0;o<e.length;o++){var a;if(r+=(a=e[o])!==null&&a!==void 0?a:"",o<t.length){const c=Re(t[o]);typeof c=="string"?r+=c:(n.set(o,c),r+=`<template ${ne}="${o}"></template>`)}}const s=document.createElement("template");s.innerHTML=r;const i=s.content;return i.querySelectorAll(`template[${ne}]`).forEach(o=>{const c=o.getAttribute(ne);if(c===null)return;const d=Number(c),l=n.get(d);l!==void 0&&o.replaceWith(l)}),i}function C(e,t=document){return t.querySelector(e)}function V(e,t,n,r){const a=n;return e.addEventListener(t,a,r),()=>e.removeEventListener(t,a,r)}function Be(e,t){let n=null,r=null;const a=()=>{n=null;const i=r;r=null,i&&e(...i)},s=((...i)=>{r=i,n!==null&&clearTimeout(n),n=setTimeout(a,t)});return s.cancel=()=>{n!==null&&(clearTimeout(n),n=null),r=null},s.flush=()=>{n!==null&&(clearTimeout(n),a())},s}var Oe=class extends Error{constructor(e,t){super(e),this.name="CartError",this.status=t}},De=150,Ne="youngle:cart:changed",He={},ze=De,re,Fe=new Set,oe=null;function We(){var e;if(re!==void 0&&re.length>0)return re;const t=typeof window!="undefined"?(e=window.Shopify)===null||e===void 0||(e=e.routes)===null||e===void 0?void 0:e.root:void 0;return t!==void 0&&t.length>0?t:"/"}function je(e){const t=We();return`${t.endsWith("/")?t:`${t}/`}${e.startsWith("/")?e.slice(1):e}`}async function Ue(e,t){if(!e.ok)throw new Oe(`Cart request to ${t} failed with status ${e.status}`,e.status);return await e.json()}function Ye(){return oe||(oe=Be(()=>{for(const t of Fe)t()},ze)),oe}async function Qe(){return Ue(await fetch(je("/cart.js"),{method:"GET",credentials:"same-origin",headers:{Accept:"application/json"}}),"/cart.js")}function Ve(){Ye()(),typeof document!="undefined"&&document.dispatchEvent(new CustomEvent(Ne,{detail:{sender:He}}))}function pe(e,t){var n;if(typeof window=="undefined")return;const r=(n=window.Shopify)===null||n===void 0?void 0:n.analytics;if(!(r===void 0||typeof r.publish!="function"))try{r.publish(e,t)}catch{}}var Ge="gid://shopify/Product/";function X(e){return e.startsWith(Ge)?e.slice(22):e}function Je(e){return`yqr-product-${X(e)}`}var Ke="youngle_promo",jt=15;function Xe(e){const t=.85*(1-e/100);return Math.floor((1-t)*100)}function Z(e,t){return e.replace(/\{\{\s*percent\s*\}\}/g,String(t))}function Ze(){try{return window.sessionStorage.getItem(Ke)}catch{return null}}function me(){var e,t,n,r,a,s,i;if(typeof window=="undefined")return null;const o=(e=window.theme)===null||e===void 0?void 0:e.promo;if(o===void 0||typeof o.key!="string"||o.key.length===0)return null;const c=(t=o.discountPercent)!==null&&t!==void 0?t:0;if(c<=0||o.sitewide!==!0&&Ze()!==o.key)return null;const d=(n=o.strings)!==null&&n!==void 0?n:{},l=(r=o.subscriptionDisplayPercent)!==null&&r!==void 0?r:0;return{discountPercent:c,subscriptionDisplayPercent:l>0?l:Xe(c),strings:{saveBadge:(a=d.saveBadge)!==null&&a!==void 0?a:"",subscriptionTodayHtml:(s=d.subscriptionTodayHtml)!==null&&s!==void 0?s:"",subscriptionFuture:(i=d.subscriptionFuture)!==null&&i!==void 0?i:""}}}function fe(e,t){return e-Math.floor(e*t.discountPercent/100)}function et(e,t,n){return n===null||e<=0?{priceCents:e,compareCents:t,promoApplied:!1}:{priceCents:fe(e,n),compareCents:Math.max(t,e),promoApplied:!0}}var A="data-yqr-atc-confirm",ye="yqr-atc-confirm-styles",ae=class extends Error{constructor(){super("User dismissed the confirmation modal"),this.name="AtcConfirmCancelledError"}},ee=null;function _e(){if(document.getElementById(ye))return;const e=document.createElement("style");e.id=ye,e.textContent=dt,document.head.appendChild(e)}function he(){if(ee&&ee.isConnected)return ee;const e=document.createElement("dialog");return e.setAttribute(A,""),document.body.appendChild(e),ee=e,e}async function tt(e){try{const t=await Qe();for(const n of t.items){const r=n.selling_plan_allocation;if(n.variant_id===e&&r!==null&&r!==void 0)return!0}return!1}catch{return!1}}function nt(e){if(!e.includes("&"))return e;const t=document.createElement("textarea");return t.innerHTML=e,t.value}function $(e,t,n){var r;return nt((r=e[t])!==null&&r!==void 0?r:n)}function te(e){var t;const n=document.createElement("template");return n.innerHTML=e,(t=n.content.textContent)!==null&&t!==void 0?t:""}function rt(e){const t=/^(.+?[.!?])\s+(\S.*)$/s.exec(e.trim());return t===null?{first:e.trim(),rest:""}:{first:t[1],rest:t[2].trim()}}function ot(e){const t=e.strings,n=rt(te(Z(t.subscriptionFuture,15)));return{onetimeBadge:te(Z(t.saveBadge,e.discountPercent)),subscribeBadge:te(Z(t.saveBadge,e.subscriptionDisplayPercent)),subscriptionToday:te(Z(t.subscriptionTodayHtml,e.subscriptionDisplayPercent)),subscriptionFuture:n.first,subscriptionTerms:n.rest}}function ve(e){return e.length>0?m`<span class="yqr-atc-confirm__badge yqr-atc-confirm__badge--promo">${e}</span>`:m``}function at(e,t,n,r){var a,s,i,o,c,d,l;const u=r===null?null:ot(r),f=e.sellingPlans,p=f[0],y=$(n,"atc_confirm_subscribe_label","Subscribe and save"),v=$(n,"atc_confirm_onetime_label","One-time purchase"),S=$(n,"atc_confirm_cta","Add to cart"),x=(K=>e.price>0?Math.round((1-K/e.price)*100):0)(p.price),g=y,h=p.price<e.price,E=h?Q("checked"):"",D=h?"":Q("checked"),N=e.title;$(n,"atc_confirm_quantity","Quantity");const L=$(n,"atc_confirm_supply_label","One month supply"),k=$(n,"atc_confirm_guarantee","30-day money-back guarantee"),B=$(n,"atc_confirm_subscribe_benefits","Cancel anytime"),I=$(n,"atc_confirm_subscribe_savings_for_life","Save {percent}% for life"),F=x>0?I.replace("{percent}",String(x)):"",H=r!==null&&u!==null&&u.subscriptionToday.length>0&&u.subscriptionFuture.length>0,z=H?"":F,P=`${H&&u.subscriptionTerms.length>0?u.subscriptionTerms:B} · ${k}`,O=/^(.*?)([.!?]?)$/s.exec((a=u==null?void 0:u.subscriptionFuture)!==null&&a!==void 0?a:""),W={body:(s=O==null?void 0:O[1])!==null&&s!==void 0?s:"",punctuation:(i=O==null?void 0:O[2])!==null&&i!==void 0?i:""},U=H?m`<span class="yqr-atc-confirm__promo-breakdown" data-yqr-promo-breakdown>
        <span class="yqr-atc-confirm__promo-line yqr-atc-confirm__promo-line--today">
          <span class="yqr-atc-confirm__promo-text">${u.subscriptionToday}</span>
        </span>
        <span class="yqr-atc-confirm__promo-line">
          <span class="yqr-atc-confirm__promo-text"
            >${W.body} (<span data-yqr-promo-renewal-price
              >${t(p.price)}</span
            >)${W.punctuation}</span
          >
        </span>
      </span>`:m``,j=ve((o=u==null?void 0:u.onetimeBadge)!==null&&o!==void 0?o:""),b=ve((c=u==null?void 0:u.subscribeBadge)!==null&&c!==void 0?c:""),w=$(n,"atc_confirm_recommended","Recommended"),M=f.length>1?m`<select
          class="yqr-atc-confirm__plan-select"
          data-yqr-plan-select
        >
          ${Q(f.map(K=>`<option value="${K.id}" data-plan-price="${K.price}" data-plan-name="${K.name.replace(/"/g,"&quot;")}">${K.name}</option>`).join(""))}
        </select>`:m`<span class="yqr-atc-confirm__plan-name yg-mono-unit--muted"
          >${p.name}</span
        >`,q=((d=u==null?void 0:u.subscribeBadge)!==null&&d!==void 0?d:"").length>0,T=h&&!q?m`<span class="yqr-atc-confirm__badge">${w}</span>`:m``,R=h?m`<span class="yqr-atc-confirm__compare-price">${t(e.price)}</span>`:m``,Y=(l=e.imageUrl)!==null&&l!==void 0?l:"",J=Y.length>0?m`<div class="yqr-atc-confirm__image-col">
        <img
          class="yqr-atc-confirm__image"
          src="${Y}"
          alt="${N}"
          loading="eager"
        />
      </div>`:m``;return m`
    <div class="yqr-atc-confirm__body${Q(Y.length>0?" yqr-atc-confirm__body--has-image":"")}">
      ${J}
      <div class="yqr-atc-confirm__content-col">
      <div class="yqr-atc-confirm__header">
        <h3 class="yqr-atc-confirm__title">${N}</h3>
        <button
          type="button"
          class="yqr-atc-confirm__close"
          data-yqr-confirm-close
          aria-label="Close"
        >\u00d7</button>
      </div>

      <fieldset class="yqr-atc-confirm__options">
        <label class="yg-card yqr-atc-confirm__option">
          <input
            type="radio"
            name="yqr-atc-plan"
            value="onetime"
            data-yqr-plan-choice="onetime"
            ${D}
          />
          <span class="yqr-atc-confirm__option-content">
            <span class="yqr-atc-confirm__option-header">
              <span class="yqr-atc-confirm__option-label">${v}</span>
              ${j}
            </span>
            <span class="yqr-atc-confirm__price-row">
              <span class="yg-display-num--sm"
                >${t(e.price)}</span
              >
            </span>
          </span>
        </label>

        <label class="yg-card yqr-atc-confirm__option">
          <input
            type="radio"
            name="yqr-atc-plan"
            value="subscribe"
            data-yqr-plan-choice="subscribe"
            ${E}
          />
          <span class="yqr-atc-confirm__option-content">
            <span class="yqr-atc-confirm__option-header">
              <span class="yqr-atc-confirm__option-label" data-yqr-subscribe-label
                >${g}</span
              >
              ${T}
              ${b}
            </span>
            <span class="yqr-atc-confirm__savings-for-life" data-yqr-savings-for-life
              >${z}</span
            >
            ${M}
            <span class="yqr-atc-confirm__price-row" data-yqr-subscribe-price>
              <span class="yg-display-num--sm"
                >${t(p.price)}</span
              >
              ${R}
            </span>
            ${U}
            <span class="yqr-atc-confirm__benefits">${P}</span>
          </span>
        </label>
      </fieldset>

      <p class="yg-mono-unit--muted yqr-atc-confirm__variant">
        ${e.variantTitle} · ${L}
      </p>

      <div class="yqr-atc-confirm__cta-row">
        <div class="yqr-atc-confirm__stepper" data-yqr-quantity-row>
          <button type="button" class="yqr-atc-confirm__stepper-btn" data-yqr-qty-minus aria-label="Decrease">\u2212</button>
          <input type="number" class="yqr-atc-confirm__stepper-input" data-yqr-qty-input value="1" min="1" max="9" />
          <button type="button" class="yqr-atc-confirm__stepper-btn" data-yqr-qty-plus aria-label="Increase">+</button>
        </div>
        <button
          type="button"
          class="yg-btn yg-btn--red yqr-atc-confirm__cta"
          data-yqr-confirm-cta
        >
          ${S}
        </button>
      </div>
      </div>
    </div>
  `}function it(e,t,n,r={}){return async a=>{if(a.items.length!==1)return e(a);const s=a.items[0],i=t.lookupByVariant(s.variantId);if(!i||i.sellingPlans.length===0||await tt(s.variantId))return e(a);_e();const o=he();o.classList.remove("yqr-atc-confirm--many-items");const c=i.sellingPlans,d=me();o.innerHTML="",o.appendChild(at(i,n,r,d));const l=i;return new Promise((u,f)=>{let p=!1;const y=o.querySelector("[data-yqr-confirm-cta]"),v=o.querySelector("[data-yqr-plan-select]"),S=o.querySelector("[data-yqr-subscribe-price]"),_=o.querySelector(".yqr-atc-confirm__option:first-child .yqr-atc-confirm__price-row"),x=o.querySelector("[data-yqr-savings-for-life]"),g=o.querySelector("[data-yqr-promo-renewal-price]"),h=o.querySelector("[data-yqr-qty-input]"),E=o.querySelector("[data-yqr-qty-minus]"),D=o.querySelector("[data-yqr-qty-plus]");function N(b,w,M){if(!b)return;const q=d===null?w:fe(w,d),T=q*M,R=d===null?"yg-display-num--sm":"yg-display-num--sm yqr-atc-confirm__price--promo",Y=M>1?` <span class="yqr-atc-confirm__unit-price">(${M} × ${n(q)})</span>`:"",J=q<l.price?` <span class="yqr-atc-confirm__compare-price">${n(l.price*M)}</span>`:"";b.innerHTML=`<span class="${R}">${n(T)}</span>`+Y+J}function L(){if(v){const b=v.selectedOptions[0];if(b)return Number(b.dataset.planPrice)}return c[0].price}function k(){return h?Math.max(1,Math.min(9,Number(h.value)||1)):1}function B(){const b=k(),w=L();N(S,w,b),N(_,l.price,b),g&&(g.textContent=n(w*b))}function I(b){h&&(h.value=String(Math.max(1,Math.min(9,Math.round(b)))),B())}const F=E?V(E,"click",()=>I(k()-1)):null,H=D?V(D,"click",()=>I(k()+1)):null,z=h?V(h,"change",()=>I(k())):null,P=v?V(v,"change",()=>{const b=v.selectedOptions[0];if(!b)return;const w=Number(b.dataset.planPrice),M=l.price>0?Math.round((1-w/l.price)*100):0;B();const q=o.querySelector("[data-yqr-promo-breakdown]")!==null;if(x&&!q){const T=$(r,"atc_confirm_subscribe_savings_for_life","Save {percent}% for life");x.textContent=M>0?T.replace("{percent}",String(M)):""}}):null,O=o.querySelectorAll('input[name="yqr-atc-plan"]'),W=[];for(const b of O)W.push(V(b,"change",B));const U=o.querySelector("[data-yqr-confirm-close]");U&&U.addEventListener("click",()=>{o.close()},{once:!0});const j=V(o,"click",b=>{b.target===o&&o.close()});y&&y.addEventListener("click",()=>{p=!0,o.close()},{once:!0}),o.addEventListener("close",()=>{j(),P&&P(),F&&F(),H&&H(),z&&z();for(const J of W)J();if(!p){f(new ae);return}const b=o.querySelector('input[name="yqr-atc-plan"]:checked'),w=(b==null?void 0:b.value)==="subscribe";let M=c[0].id;v&&(M=Number(v.value));const q=k(),T=t.lookupByHandle(l.handle),R=T&&Number(X(T.shopifyId))||s.variantId;w?pe("youngle_quiz:atc_confirm_subscribe",{product_id:R,selling_plan_id:M,quantity:q}):pe("youngle_quiz:atc_confirm_onetime",{product_id:R,quantity:q});const Y={variantId:s.variantId,quantity:q,...w?{sellingPlanId:M}:{}};e({source:a.source,items:[Y]}).then(u,f)},{once:!0}),d!==null&&B(),o.showModal()})}}function st(e,t=0){var n;if(e.sellingPlans.length!==0)return((n=e.sellingPlans[t])!==null&&n!==void 0?n:e.sellingPlans[0]).id}function ie(e,t,n,r=0){let a=0;const s=1-t/100;for(const o of e){let c=o.price;if(n&&o.sellingPlans.length>0){var i;c=((i=o.sellingPlans[r])!==null&&i!==void 0?i:o.sellingPlans[0]).price}a+=Math.round(c*s)}return a}function ct(e,t,n,r,a){var s;const i=$(n,"atc_confirm_subscribe_label","Subscribe and save"),o=$(n,"atc_confirm_onetime_label","One-time purchase"),c=$(n,"atc_confirm_cta","Add to cart"),d=$(n,"atc_confirm_recommended","Recommended"),l=$(n,"atc_confirm_subscribe_benefits","Cancel anytime"),u=$(n,"atc_confirm_guarantee","30-day money-back guarantee"),f=$(n,"atc_confirm_bundle_discount_note","{percent}% Bundle-Rabatt auf die erste Bestellung"),p=$(n,"atc_confirm_bundle_then_recurring","danach {price}/Lieferung");let y=0,v=!1;const S=e.find(q=>q.sellingPlans.length>0),_=(s=S==null?void 0:S.sellingPlans)!==null&&s!==void 0?s:[];for(const q of e)y+=q.price,q.sellingPlans.length>0&&(v=!0);function x(q){let T=0;for(const R of e)R.sellingPlans.length>q?T+=R.sellingPlans[q].price:R.sellingPlans.length>0?T+=R.sellingPlans[0].price:T+=R.price;return T}const g=x(0),h=a>0?ie(e,a,!1):y,E=a>0?ie(e,a,!0):g,D=a>0&&y>h,N=y>0?Math.round((1-g/y)*100):0,L=v&&g<y,k=L?Q("checked"):"",B=L?"":Q("checked"),I=$(n,"atc_confirm_subscribe_savings_for_life","Save {percent}% for life"),F=N>0?I.replace("{percent}",String(N)):"",H=a>0?f.replace("{percent}",String(a)):"",z=a>0&&v?p.replace("{price}",t(g)):"",P=L?m`<span class="yqr-atc-confirm__badge">${d}</span>`:m``,O=y>E?m`<span class="yqr-atc-confirm__compare-price">${t(y)}</span>`:m``,W=D?m`<span class="yqr-atc-confirm__compare-price">${t(y)}</span>`:m``,U=$(n,"atc_confirm_supply_label","One month supply"),j=e.map(q=>{var T;const R=(T=q.imageUrl)!==null&&T!==void 0?T:"",Y=R.length>0?`<img class="yqr-atc-confirm__bundle-thumb" src="${R}" alt="" loading="eager" />`:"",J=q.variantTitle?`<span class="yqr-atc-confirm__bundle-item-meta">${q.variantTitle} · ${U}</span>`:"";return`<li class="yqr-atc-confirm__bundle-item">${Y}<span class="yqr-atc-confirm__bundle-item-info"><span>${q.title}</span>${J}</span></li>`}).join(""),b=H.length>0?m`<span class="yqr-atc-confirm__bundle-bonus">${H}</span>`:m``;z.length>0?m`<span class="yqr-atc-confirm__then-recurring">${z}</span>`:m``;const w=_.length>1?m`<select
        class="yqr-atc-confirm__plan-select"
        data-yqr-bundle-plan-select
      >
        ${Q(_.map((q,T)=>`<option value="${T}" data-plan-name="${q.name.replace(/"/g,"&quot;")}">${q.name}</option>`).join(""))}
      </select>`:_.length===1?m`<span class="yqr-atc-confirm__plan-name yg-mono-unit--muted">${_[0].name}</span>`:m``,M=v?m`<label class="yg-card yqr-atc-confirm__option">
          <input
            type="radio"
            name="yqr-atc-plan"
            value="subscribe"
            data-yqr-plan-choice="subscribe"
            ${k}
          />
          <span class="yqr-atc-confirm__option-content">
            <span class="yqr-atc-confirm__option-header">
              <span class="yqr-atc-confirm__option-label">${i}</span>
              ${P}
            </span>
            <span class="yqr-atc-confirm__savings-group">
              <span class="yqr-atc-confirm__savings-for-life" data-yqr-savings-for-life>${F}</span>
              ${b}
            </span>
            ${w}
            <span class="yqr-atc-confirm__price-row" data-yqr-subscribe-price>
              <span class="yg-display-num--sm">${t(E)}</span>
              ${O}
            </span>
            <span class="yqr-atc-confirm__then-recurring" data-yqr-then-recurring>${z}</span>
            <span class="yqr-atc-confirm__benefits">${l} · ${u}</span>
          </span>
        </label>`:m``;return m`
    <div class="yqr-atc-confirm__body">
      <div class="yqr-atc-confirm__content-col">
        <div class="yqr-atc-confirm__header">
          <h3 class="yqr-atc-confirm__title">${r}</h3>
          <button
            type="button"
            class="yqr-atc-confirm__close"
            data-yqr-confirm-close
            aria-label="Close"
          >\u00d7</button>
        </div>

        <ul class="yqr-atc-confirm__bundle-list">
          ${Q(j)}
        </ul>

        <fieldset class="yqr-atc-confirm__options">
          <label class="yg-card yqr-atc-confirm__option">
            <input
              type="radio"
              name="yqr-atc-plan"
              value="onetime"
              data-yqr-plan-choice="onetime"
              ${B}
            />
            <span class="yqr-atc-confirm__option-content">
              <span class="yqr-atc-confirm__option-label">${o}</span>
              ${D?b:m``}
              <span class="yqr-atc-confirm__price-row">
                <span class="yg-display-num--sm">${t(h)}</span>
                ${W}
              </span>
            </span>
          </label>

          ${M}
        </fieldset>

        <div class="yqr-atc-confirm__cta-row">
          <button
            type="button"
            class="yg-btn yg-btn--red yqr-atc-confirm__cta"
            data-yqr-confirm-cta
          >
            ${c}
          </button>
        </div>
      </div>
    </div>
  `}function lt(e,t,n,r,a=0){var s;if(!e.some(f=>f.sellingPlans.length>0))return Promise.resolve({isSubscribe:!1,planIndex:0});_e();const i=he();i.classList.toggle("yqr-atc-confirm--many-items",e.length>3),i.innerHTML="",i.appendChild(ct(e,t,n,r,a));const o=$(n,"atc_confirm_bundle_then_recurring","danach {price}/Lieferung"),c=$(n,"atc_confirm_subscribe_savings_for_life","Save {percent}% for life"),d=e.find(f=>f.sellingPlans.length>0),l=(s=d==null?void 0:d.sellingPlans)!==null&&s!==void 0?s:[];function u(f){let p=0;for(const y of e)y.sellingPlans.length>f?p+=y.sellingPlans[f].price:y.sellingPlans.length>0?p+=y.sellingPlans[0].price:p+=y.price;return p}return new Promise((f,p)=>{let y=!1;const v=i.querySelector("[data-yqr-confirm-cta]"),S=i.querySelector("[data-yqr-confirm-close]"),_=i.querySelector("[data-yqr-bundle-plan-select]"),x=i.querySelector("[data-yqr-subscribe-price]"),g=i.querySelector("[data-yqr-savings-for-life]"),h=i.querySelector("[data-yqr-then-recurring]");let E=0;for(const L of e)E+=L.price;const D=_?V(_,"change",()=>{const L=Number(_.value),k=u(L),B=a>0?ie(e,a,!0,L):k;if(x){const I=E>B?` <span class="yqr-atc-confirm__compare-price">${t(E)}</span>`:"";x.innerHTML=`<span class="yg-display-num--sm">${t(B)}</span>`+I}if(g){const I=E>0?Math.round((1-k/E)*100):0;g.textContent=I>0?c.replace("{percent}",String(I)):""}h&&(h.textContent=a>0&&l.length>0?o.replace("{price}",t(k)):"")}):null;S&&S.addEventListener("click",()=>{i.close()},{once:!0});const N=V(i,"click",L=>{L.target===i&&i.close()});v&&v.addEventListener("click",()=>{y=!0,i.close()},{once:!0}),i.addEventListener("close",()=>{if(N(),D&&D(),!y){p(new ae);return}const L=i.querySelector('input[name="yqr-atc-plan"]:checked'),k=_?Number(_.value):0;f({isSubscribe:(L==null?void 0:L.value)==="subscribe",planIndex:k})},{once:!0}),i.showModal()})}var dt=`
[${A}] {
  border: 0;
  padding: 0;
  max-width: 480px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  background: var(--pure-white, #f8f8f8);
  color: var(--cold-black, #0a0a0a);
  font-family: var(--font-sans, sans-serif);
  /* Desktop: centered modal */
  margin: auto;
  border-radius: 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

@media (max-width: 719px) {
  [${A}] {
    /* Mobile: bottom-attached drawer */
    margin: auto auto 0 auto;
    inset: auto 0 0 0;
    border-radius: 0;
    box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.12);
  }
}

@media (max-width: 719px) and (max-height: 700px) {
  [${A}] {
    max-height: 100vh;
    max-height: 100dvh;
    height: 100%;
  }
  [${A}] .yqr-atc-confirm__body {
    min-height: 100%;
  }
  [${A}] .yqr-atc-confirm__content-col {
    flex: 1;
  }
  [${A}] .yqr-atc-confirm__cta-row {
    margin-top: auto;
  }
  [${A}]:has(.yqr-atc-confirm__bundle-list) .yqr-atc-confirm__plan-select,
  [${A}]:has(.yqr-atc-confirm__bundle-list) .yqr-atc-confirm__benefits {
    display: none;
  }
}

@media (max-width: 719px) {
  [${A}].yqr-atc-confirm--many-items {
    max-height: 100vh;
    max-height: 100dvh;
    height: 100%;
  }
}

[${A}]::backdrop {
  background: rgba(10, 10, 10, 0.45);
}

.yqr-atc-confirm__body {
  position: relative;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  animation: yqrAtcConfirmIn 220ms cubic-bezier(.2,.7,.2,1) both;
}

.yqr-atc-confirm__body::before {
  content: none;
}

.yqr-atc-confirm__image-col {
  display: none;
}

.yqr-atc-confirm__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.yqr-atc-confirm__content-col {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-24, 24px);
  padding: var(--space-24, 24px) var(--gutter-mobile, 20px) calc(var(--space-24, 24px) + env(safe-area-inset-bottom));
}

@media (min-width: 720px) {
  .yqr-atc-confirm__content-col {
    padding: var(--space-32, 32px);
  }

  [${A}]:has(.yqr-atc-confirm__body--has-image) {
    max-width: 520px;
  }

  .yqr-atc-confirm__body--has-image .yqr-atc-confirm__image-col {
    display: none;
  }
}

.yqr-atc-confirm__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-12, 12px);
}

.yqr-atc-confirm__close {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border: 1px solid var(--gray-20, #c8c8d0);
  border-radius: 50%;
  background: transparent;
  color: var(--cold-black, #0a0a0a);
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  transition: border-color 160ms ease, background 160ms ease;
}

.yqr-atc-confirm__close:hover,
.yqr-atc-confirm__close:focus-visible {
  border-color: var(--gray-50, #64647a);
  background: var(--gray-05, #f0f0f4);
}

.yqr-atc-confirm__title {
  margin: 0;
  color: var(--cold-black, #0a0a0a);
  font-family: var(--font-sans, sans-serif);
  font-weight: 500;
  font-size: clamp(20px, 2.5vw, 24px);
  line-height: 1.2;
  letter-spacing: -0.01em;
}

.yqr-atc-confirm__options {
  border: 0;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-12, 12px);
}

.yqr-atc-confirm__option {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
  gap: var(--space-12, 12px);
  cursor: pointer;
  padding: var(--space-16, 16px);
  border-radius: 15px;
  transition: border-color 160ms cubic-bezier(.2,.7,.2,1);
}

.yqr-atc-confirm__option:has(input:checked) {
  border-color: var(--cold-black, #0a0a0a);
}

.yqr-atc-confirm__option input[type="radio"] {
  appearance: none;
  margin: 0;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border: 2px solid var(--cold-black, #0a0a0a);
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  margin-top: 2px;
}

.yqr-atc-confirm__option input[type="radio"]:checked {
  border-color: var(--cold-black, #0a0a0a);
  background: var(--fire-red, #ff4b00);
  box-shadow: inset 0 0 0 3px var(--pure-white, #f8f8f8);
}

.yqr-atc-confirm__option-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-8, 8px);
}

.yqr-atc-confirm__option-label {
  font-weight: 500;
}

.yqr-atc-confirm__plan-select {
  appearance: none;
  font-family: var(--font-mono, monospace);
  font-size: 13px;
  border: var(--hairline, 1px solid #e0e0e4);
  border-radius: var(--radius-sm, 4px);
  padding: var(--space-8, 8px) var(--space-32, 32px) var(--space-8, 8px) var(--space-12, 12px);
  background: var(--pure-white, #f8f8f8) url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%230a0a0a'/%3E%3C/svg%3E") no-repeat right 12px center;
  color: var(--cold-black, #0a0a0a);
  width: 100%;
  max-width: 200px;
  cursor: pointer;
}

.yqr-atc-confirm__price-row {
  display: flex;
  align-items: baseline;
  gap: var(--space-8, 8px);
  flex-wrap: wrap;
}

.yqr-atc-confirm__plan-select + .yqr-atc-confirm__price-row,
.yqr-atc-confirm__plan-name + .yqr-atc-confirm__price-row {
  margin-top: var(--space-8, 8px);
}

.yqr-atc-confirm__variant {
  margin: 0;
}

.yqr-atc-confirm__cta-row {
  display: flex;
  align-items: stretch;
  gap: var(--space-12, 12px);
}

.yqr-atc-confirm__stepper {
  display: inline-flex;
  align-items: center;
  border: var(--hairline, 1px solid #e0e0e4);
  border-radius: var(--radius-pill, 999px);
  overflow: hidden;
  flex-shrink: 0;
}

.yqr-atc-confirm__stepper-btn {
  width: 36px;
  height: 36px;
  border: 0;
  background: transparent;
  color: var(--cold-black, #0a0a0a);
  font-family: var(--font-mono, monospace);
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
  outline: none;
}

[${A}] .yqr-atc-confirm__stepper-input {
  width: 40px;
  height: 36px;
  border: 0;
  border-left: var(--hairline, 1px solid #e0e0e4);
  border-right: var(--hairline, 1px solid #e0e0e4);
  background: transparent;
  text-align: center;
  font-family: var(--font-mono, monospace);
  font-size: 14px;
  font-weight: 600;
  color: #0a0a0a;
  padding: 0;
  margin: 0;
  line-height: 36px;
  -moz-appearance: textfield;
  appearance: textfield;
}

[${A}] .yqr-atc-confirm__stepper-input::-webkit-inner-spin-button,
[${A}] .yqr-atc-confirm__stepper-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.yqr-atc-confirm__unit-price {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  color: var(--gray-50, #64647a);
}

.yqr-atc-confirm__option-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-8, 8px);
}

.yqr-atc-confirm__badge {
  font-family: var(--font-mono, monospace);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: var(--fire-red, #ff4b00);
  color: var(--pure-white, #f8f8f8);
  padding: 2px 8px;
  border-radius: var(--radius-pill, 999px);
  white-space: nowrap;
}

.yqr-atc-confirm__savings-for-life {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  font-weight: 500;
  color: var(--fire-red, #ff4b00);
  padding-bottom: var(--space-4, 4px);
}

.yqr-atc-confirm__savings-for-life:empty {
  display: none;
}

.yqr-atc-confirm__price--promo {
  color: var(--fire-red, #ff4b00);
}

.yqr-atc-confirm__promo-breakdown {
  display: flex;
  flex-direction: column;
  gap: var(--space-4, 4px);
}

.yqr-atc-confirm__promo-line {
  display: flex;
  align-items: baseline;
  gap: var(--space-8, 8px);
  font-family: var(--font-sans, sans-serif);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--cold-black, #0a0a0a);
}

.yqr-atc-confirm__promo-line::before {
  content: '';
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--cold-black, #0a0a0a);
  transform: translateY(-1px);
}

.yqr-atc-confirm__promo-line--today::before {
  background: var(--fire-red, #ff4b00);
}

.yqr-atc-confirm__promo-text {
  flex: 1;
}

[data-yqr-promo-renewal-price] {
  white-space: nowrap;
}

.yqr-atc-confirm__compare-price {
  font-family: var(--font-mono, monospace);
  font-size: 13px;
  color: var(--gray-30, #9494a3);
  text-decoration: line-through;
}

.yqr-atc-confirm__benefits {
  font-family: var(--font-mono, monospace);
  font-size: 11px;
  color: var(--gray-50, #64647a);
  margin-top: var(--space-4, 4px);
}


.yqr-atc-confirm__cta {
  flex: 1;
}

.yqr-atc-confirm__bundle-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-8, 8px);
}

.yqr-atc-confirm__bundle-item {
  display: flex;
  align-items: center;
  gap: var(--space-12, 12px);
  font-family: var(--font-sans, sans-serif);
  font-size: 14px;
  color: var(--cold-black, #0a0a0a);
}

.yqr-atc-confirm__bundle-thumb {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: var(--radius-sm, 4px);
  flex-shrink: 0;
}

.yqr-atc-confirm__bundle-item-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.yqr-atc-confirm__bundle-item-meta {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  color: var(--gray-50, #64647a);
}

.yqr-atc-confirm__savings-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.yqr-atc-confirm__savings-group .yqr-atc-confirm__savings-for-life {
  padding-bottom: 0;
}

.yqr-atc-confirm__bundle-bonus {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  font-weight: 500;
  color: var(--fire-red, #ff4b00);
}

.yqr-atc-confirm__then-recurring {
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  color: var(--gray-50, #64647a);
}

@keyframes yqrAtcConfirmIn {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .yqr-atc-confirm__option {
    transition: none;
  }
  .yqr-atc-confirm__body {
    animation: none;
  }
}
`,be="__youngleCascadeRegistry";function ut(){let e=window[be];return e===void 0&&(e=new Map,window[be]=e),e}function pt(e,t){const n=ut();return n.set(e,t),()=>{n.delete(e)}}function mt(e,t,n,r){var a,s,i,o;const c=(a=e.matched_health_markers)!==null&&a!==void 0?a:[],d=c.length>0,l=d?n.why_this_summary_with_markers:n.why_this_summary_without_markers,u=t!=null?t:{},f=[];for(const x of c){const g=u[x],h=m`
      <li class="yqr-why__item">
        <strong class="yqr-why__marker">${x}</strong>
        ${ft(g,n)}
      </li>
    `.querySelector("li");h!==null&&f.push(h)}const p=f.length>0?m`<ul class="yqr-why__list" role="list">${f}</ul>`:null,y=(s=e.recommendation_reason)!==null&&s!==void 0?s:"",v=!d&&y.trim().length>0?m`<p class="yqr-why__reason">${y}</p>`:null,S=m`
    <details class="yqr-why">
      <summary class="yqr-why__summary">${l}</summary>
      <div class="yqr-why__body">
        ${p!=null?p:""}
        ${v!=null?v:""}
      </div>
    </details>
  `.querySelector("details");if(S===null)throw new Error("renderWhyThis: expected a details root in the template output");const _=(i=r==null||(o=r.analyticsProductId)===null||o===void 0?void 0:o.trim())!==null&&i!==void 0?i:"";return _.length>0&&S.setAttribute("data-yqr-product-id",_),S}function ft(e,t){if(e===void 0)return m`<p class="yqr-why__trace yqr-why__trace--missing"></p>`;const n=e.answer.trim(),r=e.question.trim();return n.length===0&&r.length===0?m`<p class="yqr-why__trace yqr-why__trace--missing"></p>`:m`<p class="yqr-why__trace">
    ${t.why_this_you_said_prefix}
    &quot;${n}&quot;
    ${t.why_this_when_asked_prefix}
    &quot;${r}&quot;
  </p>`}function yt(e,t){const n=e.trim(),r=t.trim();return n.length===0&&r.length===0?"":n.length>0&&r.length>0?`${n} ${r}`:n||r}function _t(e,t){if(t.replaceChildren(),e.length!==0)for(const f of e){var n,r,a,s,i,o,c,d,l,u;const p=f.name.trim();if(p.length===0)continue;const y=yt((n=(r=f.amount_text)===null||r===void 0?void 0:r.trim())!==null&&n!==void 0?n:"",(a=(s=f.unit)===null||s===void 0?void 0:s.trim())!==null&&a!==void 0?a:""),v=(i=(o=f.scientific_name)===null||o===void 0?void 0:o.trim())!==null&&i!==void 0?i:"",S=(c=(d=f.description)===null||d===void 0?void 0:d.trim())!==null&&c!==void 0?c:"",_=(l=(u=f.note)===null||u===void 0?void 0:u.trim())!==null&&l!==void 0?l:"";if(!(S.length>0||v.length>0||_.length>0)){const h=m`<div class="yqr-spotlight__ingredient yqr-spotlight__ingredient--static">
        <div class="yqr-spotlight__ingredient-row">
          <span class="yqr-spotlight__ingredient-name">${p}</span>
          ${y.length>0?m`<span class="yqr-spotlight__ingredient-amount">${y}</span>`:""}
        </div>
      </div>`;t.appendChild(h);continue}const x=[];if(v.length>0){const h=m`<p class="yqr-spotlight__ingredient-scientific">${v}</p>`;x.push(h)}if(S.length>0){const h=m`<p class="yqr-spotlight__ingredient-desc">${S}</p>`;x.push(h)}if(_.length>0){const h=m`<p class="yqr-spotlight__ingredient-note">${_}</p>`;x.push(h)}const g=m`<details class="yqr-spotlight__ingredient">
      <summary>
        <span class="yqr-spotlight__ingredient-name">${p}</span>
        ${y.length>0?m`<span class="yqr-spotlight__ingredient-amount">${y}</span>`:""}
        <span class="yqr-spotlight__ingredient-chevron" aria-hidden="true">&#x25BE;</span>
      </summary>
      <div class="yqr-spotlight__ingredient-body">
        ${x}
      </div>
    </details>`;t.appendChild(g)}}function ht(e,t){if(e.length===0||t.length===0)return e;const n=e.toLowerCase(),r=t.toLowerCase();if(!n.startsWith(r))return e;const a=e.slice(t.length).replace(/^[\s:·\-–—]+/,"");return a.length===0?e:a.charAt(0).toUpperCase()+a.slice(1)}function vt(e){let t=0;for(const n of e)(t===0||n.price<t)&&(t=n.price);return t}function bt(e,t,n,r,a){var s;const i=C("[data-yqr-row-card-price-from]",e),o=C("[data-yqr-row-card-price]",e),c=C("[data-yqr-row-card-compare]",e);if(i===null||o===null||c===null)return;const d=vt(t.sellingPlans),l=n.length>0&&d>0&&d<t.price,u=et(l?d:t.price,!l&&t.compareAtPrice>t.price?t.compareAtPrice:0,a);i.textContent=l?n:"",i.classList.toggle("yqr-row-card__price-from--hidden",!l),o.textContent=r(u.priceCents),o.classList.toggle("yqr-row-card__price--promo",u.promoApplied);const f=(s=c.closest(".yqr-row-card__compare"))!==null&&s!==void 0?s:c,p=u.compareCents>u.priceCents;c.textContent=p?r(u.compareCents):"",f.classList.toggle("yqr-row-card__compare--hidden",!p)}function gt(e,t,n){var r,a,s,i,o,c,d;const l=(r=e.editorial)!==null&&r!==void 0?r:null,u=l!==null&&l.card_blurb!==null?l.card_blurb.trim():"",f=ht(u.length>0?u:((a=e.recommendation_reason)!==null&&a!==void 0?a:"").trim(),e.title),p=m`<article
    class="yqr-row-card ${n.densityClass}"
    data-yqr-row-card
    data-shopify-product-id="${X(e.shopify_id)}"
  >
    <div class="yqr-row-card__anchor" data-yqr-product-anchor aria-hidden="true"></div>
    <div class="yqr-row-card__media" data-yqr-row-card-media></div>
    <div class="yqr-row-card__body">
      <h3 class="yqr-row-card__title" data-yqr-row-card-title></h3>
      <p class="yqr-row-card__blurb yqr-row-card__blurb--hidden" data-yqr-row-card-blurb></p>
      <div class="yqr-row-card__why" data-yqr-row-card-why></div>
      <div class="yqr-row-card__price-row">
        <span class="yqr-row-card__price-from yqr-row-card__price-from--hidden" data-yqr-row-card-price-from></span>
        <span class="yqr-row-card__price" data-yqr-row-card-price></span>
        <s class="yqr-row-card__compare yqr-row-card__compare--hidden">
          <span data-yqr-row-card-compare></span>
        </s>
        <span class="yqr-row-card__supply-note yqr-row-card__supply-note--hidden" data-yqr-row-card-supply-note></span>
      </div>
      <div class="yqr-row-card__actions">
        <button type="button" class="button yqr-row-card__atc" data-yqr-row-card-atc></button>
        <button type="button" class="yqr-row-card__learn-more yqr-row-card__learn-more--hidden" data-yqr-row-card-learn-more></button>
      </div>
      <div class="yqr-row-card__sources" hidden aria-hidden="true">
        <div data-yqr-row-card-story></div>
        <div data-yqr-row-card-mechanism></div>
        <div data-yqr-row-card-ingredients></div>
      </div>
    </div>
  </article>`.querySelector("[data-yqr-row-card]");if(!(p instanceof HTMLElement))throw new TypeError("createCatalogRowCardElement: expected article root");const y=C("[data-yqr-product-anchor]",p),v=C("[data-yqr-row-card-media]",p),S=C("[data-yqr-row-card-title]",p),_=C("[data-yqr-row-card-blurb]",p),x=C("[data-yqr-row-card-why]",p),g=C("[data-yqr-row-card-supply-note]",p),h=C("[data-yqr-row-card-atc]",p);if(y===null||v===null||S===null||_===null||x===null||g===null||h===null)throw new TypeError("createCatalogRowCardElement: missing internal slot");if(y.id=Je(e.shopify_id),S.textContent=e.title,f.length>0?(_.textContent=f,_.classList.remove("yqr-row-card__blurb--hidden")):(_.textContent="",_.classList.add("yqr-row-card__blurb--hidden")),x.replaceChildren(),n.showWhyThis){const P={editorial:l};e.matched_health_markers!==void 0&&(P.matched_health_markers=e.matched_health_markers),e.recommendation_reason!==void 0&&(P.recommendation_reason=e.recommendation_reason);const O=mt(P,n.healthMarkerSources,n.whyThisLabels,{analyticsProductId:X(e.shopify_id)});x.appendChild(O)}bt(p,t,(s=n.priceFromLabel)!==null&&s!==void 0?s:"",n.formatPrice,me());const E=(i=n.supplyNoteLabel)!==null&&i!==void 0?i:"";E.length>0?(g.textContent=E,g.classList.remove("yqr-row-card__supply-note--hidden")):(g.textContent="",g.classList.add("yqr-row-card__supply-note--hidden")),v.replaceChildren();const D=(o=(c=e.image_url)===null||c===void 0?void 0:c.trim())!==null&&o!==void 0?o:"";if(D.length>0){const P=m`<img
      class="yqr-row-card__image"
      src="${D}"
      alt="${e.title}"
      loading="lazy"
      decoding="async"
    />`.querySelector("img");P!==null&&v.appendChild(P)}const N=(d=n.learnMoreLabel)!==null&&d!==void 0?d:"",L=C("[data-yqr-row-card-learn-more]",p),k=C("[data-yqr-row-card-story]",p),B=C("[data-yqr-row-card-mechanism]",p),I=C("[data-yqr-row-card-ingredients]",p);if(L!==null&&N.length>0){var F,H;const P=l!==null&&l.story!==null&&l.story.trim().length>0,O=((F=e.description)!==null&&F!==void 0?F:"").trim().length>0,W=l!==null&&l.mechanism!==null&&l.mechanism.trim().length>0,U=((H=e.ingredients)!==null&&H!==void 0?H:[]).length>0;if(P||O||W||U){if(L.textContent=N,L.classList.remove("yqr-row-card__learn-more--hidden"),k!==null){var z;const j=P?l.story.trim():((z=e.description)!==null&&z!==void 0?z:"").trim();if(j.length>0)for(const b of j.split(/\n\s*\n/).filter(w=>w.trim().length>0)){const w=document.createElement("p");w.className="yqr-row-card__story-p",w.textContent=b.trim(),k.appendChild(w)}}if(B!==null&&W){const j=l.mechanism.trim();for(const b of j.split(/\n\s*\n/).filter(w=>w.trim().length>0)){const w=document.createElement("p");w.className="yqr-row-card__mechanism-p",w.textContent=b.trim(),B.appendChild(w)}}I!==null&&U&&_t(e.ingredients,I)}}return p}function qt(e,t,n,r,a,s){const i=C("[data-yqr-row-card-atc]",e);if(i===null)return;i.textContent=t.available?a:s,i.disabled=!t.available,i.setAttribute("data-variant-id",String(t.variantId));const o=t.variantId,c=i.cloneNode(!0);i.replaceWith(c),c.addEventListener("click",()=>{t.available&&c.getAttribute("data-yqr-added")!=="true"&&r({source:n,items:[{variantId:o,quantity:1}]}).catch(d=>{const l=d instanceof Error?d.message:String(d);console.warn("[YQR-row-card]","Add to cart failed",l)})})}var ge="yqr-rec-overview--skeleton",qe="yqr-rec-overview--revealed",wt=".yqr-rec-overview__real-content";function xt(e,t){const n=e.result;let r;switch(t){case"primary_secondary":var a,s,i;r=[...(a=n.formulas)!==null&&a!==void 0?a:[],...(s=n.foundations)!==null&&s!==void 0?s:[],...(i=n.sports)!==null&&i!==void 0?i:[]].slice(0,2);break;case"foundations":var o;r=(o=n.foundations)!==null&&o!==void 0?o:[];break;default:var c,d,l;r=[...(c=n.formulas)!==null&&c!==void 0?c:[],...(d=n.foundations)!==null&&d!==void 0?d:[],...(l=n.sports)!==null&&l!==void 0?l:[]];break}return r.filter(u=>u.shopify_id!==void 0&&u.shopify_id.length>0)}function Ct(e,t,n){const r=xt(t,e.productSlot);if(r.length===0)return xe(e),!1;$t(e,t),e.listHost.replaceChildren();for(const a of r){const s=t.catalog.lookup(a.shopify_id);if(s===null)continue;const i=gt(a,s,{formatPrice:n.formatPrice,healthMarkerSources:n.healthMarkerSources,whyThisLabels:n.whyThisLabels,showWhyThis:!0,addToCartSource:"recommendation-overview",densityClass:"yqr-row-card--comfortable",learnMoreLabel:n.learnMoreLabel,priceFromLabel:n.priceFromLabel,supplyNoteLabel:n.supplyNoteLabel});qt(i,s,"recommendation-overview",n.addToCart,n.atcLabel,n.soldOutLabel),e.listHost.appendChild(i)}return e.listHost.children.length===0?(xe(e),!1):(Mt(e,r,t,n),!0)}function St(e,t){switch(e){case"primary_secondary":return t.formulasIntro;case"foundations":return t.foundationsIntro;case"all":return t.formulasIntro;default:return null}}function $t(e,t){var n,r,a,s,i,o,c;const d=St(e.productSlot,t.aiSummary);if(d!==null){e.descriptionHost.textContent=d,e.descriptionHost.removeAttribute("hidden");return}const l=(n=t.result.formulas)===null||n===void 0?void 0:n[0],u=((r=(a=t.result.foundations)===null||a===void 0?void 0:a.length)!==null&&r!==void 0?r:0)+((s=(i=t.result.sports)===null||i===void 0?void 0:i.length)!==null&&s!==void 0?s:0)+(((o=(c=t.result.formulas)===null||c===void 0?void 0:c.length)!==null&&o!==void 0?o:0)>1?1:0);if(l===void 0){e.descriptionHost.setAttribute("hidden","");return}const f=l.title;let p;u>0?p=`${f} ist deine zentrale Empfehlung, gezielt auf deine wichtigsten Bedürfnisse abgestimmt. Ergänzt wird sie durch ${u} weitere${u===1?"s":""} Supplement${u===1?"":"s"}, die deine Routine abrunden und zusätzliche Bereiche unterstützen.`:p=`${f} ist deine zentrale Empfehlung, gezielt auf deine wichtigsten Bedürfnisse abgestimmt.`,e.descriptionHost.textContent=p,e.descriptionHost.removeAttribute("hidden")}function Lt(){var e;const t=typeof window!="undefined"?(e=window.Shopify)===null||e===void 0||(e=e.routes)===null||e===void 0?void 0:e.root:void 0;return t!==void 0&&t.length>0?t:"/"}function Tt(e){const t=Lt(),n=t.endsWith("/")?t:`${t}/`;return fetch(`${n}cart/update.js`,{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({discount:e})}).then(()=>{}).catch(()=>{})}function kt(e,t){let n=0;for(const r of e){const a=t.catalog.lookup(r.shopify_id);a!==null&&(n+=a.price)}return n}function Et(e,t){let n=0;for(const r of e){const a=t.catalog.lookup(r.shopify_id);if(a===null)continue;const s=a.sellingPlans;if(s.length===0){n+=a.price;continue}let i=s[0].price;for(const o of s)o.price<i&&(i=o.price);n+=i}return n}function Pt(e,t,n,r){let a=0;const s=1-n/100;for(const i of e){const o=t.catalog.lookup(i.shopify_id);if(o===null)continue;let c=o.price;if(r&&o.sellingPlans.length>0){let d=o.sellingPlans[0].price;for(const l of o.sellingPlans)l.price<d&&(d=l.price);c=d}a+=Math.round(c*s)}return a}function At(e,t){const n=[];for(const r of e){const a=t.catalog.lookup(r.shopify_id);a!==null&&a.available&&n.push(a)}return n}function It(e,t,n,r=0){const a=[];for(const s of e){const i=t.catalog.lookup(s.shopify_id);if(i!==null&&i.available){const o={variantId:i.variantId,quantity:1};if(n){const c=st(i,r);c!==void 0&&(o.sellingPlanId=c)}a.push(o)}}return a}function Mt(e,t,n,r){if(!e.bundleEnabled||e.bundleHost===null)return;if(t.length<e.bundleMinItems){e.bundleHost.setAttribute("hidden","");return}const a=e.bundleHost,s=C("[data-yqr-rec-overview-bundle-intro]",a),i=C("[data-yqr-rec-overview-bundle-total]",a),o=C("[data-yqr-rec-overview-bundle-compare-wrap]",a),c=C("[data-yqr-rec-overview-bundle-compare]",a),d=C("[data-yqr-rec-overview-bundle-save]",a),l=C("[data-yqr-rec-overview-bundle-atc]",a);if(i===null||o===null||c===null||d===null||l===null)return;s!==null&&(s.textContent=r.bundleIntroLabel);const u=kt(t,n),f=Et(t,n),p=e.bundleDiscountPercent,y=p>0?Pt(t,n,p,!0):f,v=u-y;i.textContent=r.formatPrice(y),v>0?(o.removeAttribute("hidden"),c.textContent=r.formatPrice(u),d.removeAttribute("hidden"),d.textContent=r.bundleFromSavingsTemplate.replaceAll("{{amount}}",r.formatPrice(v))):(o.setAttribute("hidden",""),d.setAttribute("hidden",""));const S=e.bundleCtaLabel.trim().length>0?e.bundleCtaLabel:r.bundleDefaultCtaLabel,_=l.cloneNode(!0);_.textContent=S,_.disabled=!1,l.replaceWith(_),_.addEventListener("click",()=>{const x=At(t,n);x.length!==0&&(_.disabled=!0,lt(x,r.formatPrice,r.bundleConfirmLabels,r.bundleConfirmTitle,e.bundleDiscountPercent).then(g=>{const h=It(t,n,g.isSubscribe,g.planIndex);return h.length===0?(_.disabled=!1,Promise.resolve()):(_.classList.add("yqr-rec-overview__bundle-atc--loading"),r.bundleAddToCart({source:"rec-overview-bundle",items:h}).then(()=>{if(e.bundleDiscountCode.length>0)return Tt(e.bundleDiscountCode).then(()=>{Ve()})}).finally(()=>{_.disabled=!1,_.classList.remove("yqr-rec-overview__bundle-atc--loading")}))}).catch(g=>{if(_.disabled=!1,!(g instanceof ae))throw g}))}),a.removeAttribute("hidden")}function we(e){const t=e.root.querySelector(wt);t!==null&&t.removeAttribute("hidden"),e.root.classList.remove(ge),e.root.classList.add(qe),e.root.removeAttribute("aria-hidden")}function xe(e){e.listHost.replaceChildren(),e.root.setAttribute("hidden",""),e.root.classList.add(ge),e.root.classList.remove(qe),e.root.setAttribute("aria-hidden","true")}var Ce="[data-yqr-recommendation-overview-list]",Se="[data-yqr-recommendation-overview-description]",Rt="[data-yqr-rec-overview-bundle]",G=class extends Error{constructor(e){super(e),this.name="OverviewConfigError"}};function Bt(e){return typeof CSS!="undefined"&&typeof CSS.escape=="function"?CSS.escape(e):e.replace(/["\\]/g,t=>`\\${t}`)}function Ot(e){return typeof e=="object"&&e!==null&&!Array.isArray(e)}var Dt=new Set(["all","primary_secondary","foundations"]);function Nt(e){const t=e.product_slot;return typeof t=="string"&&Dt.has(t)?t:"all"}function $e(e,t,n,r){return typeof e!="number"||Number.isNaN(e)?r:Math.min(n,Math.max(t,Math.round(e)))}function Ht(e,t){var n,r;const a=(n=e.ownerDocument)!==null&&n!==void 0?n:document,s=`script[data-yqr-recommendation-overview-config][data-section-id="${Bt(t)}"]`,i=a.querySelector(s);if(!(i instanceof HTMLScriptElement))throw new G(`Recommendation-overview config blob missing for section id "${t}".`);return(r=i.textContent)!==null&&r!==void 0?r:""}function zt(e){var t,n;const r=e.getAttribute("data-section-id");if(r===null||r.length===0)throw new G("Recommendation-overview section is missing required attribute: data-section-id");const a=C(Ce,e);if(a===null)throw new G(`Recommendation-overview section "${r}" is missing ${Ce}.`);const s=C(Se,e);if(s===null)throw new G(`Recommendation-overview section "${r}" is missing ${Se}.`);const i=Ht(e,r);let o;try{o=JSON.parse(i)}catch(c){throw new G(`Recommendation-overview config blob for section "${r}" is not valid JSON: ${c.message}`)}if(!Ot(o))throw new G(`Recommendation-overview config blob for section "${r}" must be a JSON object.`);return{root:e,sectionId:r,listHost:a,descriptionHost:s,productSlot:Nt(o),bundleEnabled:!!o.bundle_enabled,bundleDiscountPercent:$e(o.bundle_discount_percent,0,50,0),bundleDiscountCode:String((t=o.bundle_discount_code)!==null&&t!==void 0?t:""),bundleCtaLabel:String((n=o.bundle_cta_label)!==null&&n!==void 0?n:""),bundleMinItems:$e(o.bundle_min_items,1,5,2),bundleHost:C(Rt,e)}}var Ft="[data-yqr-recommendation-overview]",Le="data-yqr-recommendation-overview-mounted";function Te(){const e=document.querySelectorAll(Ft);if(e.length!==0){for(const t of e)if(t.getAttribute(Le)!=="true")try{Wt(t),t.setAttribute(Le,"true")}catch(n){if(n instanceof G){console.warn(`[YQR-rec-overview] ${n.message}`);continue}throw n}}}function Wt(e){const t=zt(e);Ae(n=>{const r=n.i18n,a={why_this_summary_with_markers:r.why_this_summary_with_markers||"Why this for you?",why_this_summary_without_markers:r.why_this_summary_without_markers||"Why do we recommend this?",why_this_safety_note_heading:r.why_this_safety_note_heading||"Safety note",why_this_you_said_prefix:r.why_this_you_said_prefix||"You said",why_this_when_asked_prefix:r.why_this_when_asked_prefix||"when asked"},s=it(de,n.catalog,n.formatPrice,r);if(Ct(t,n,{formatPrice:n.formatPrice,healthMarkerSources:n.result.health_marker_sources,whyThisLabels:a,addToCart:s,bundleAddToCart:de,atcLabel:r.row_card_cta_label||"Configure now",soldOutLabel:r.sold_out||"Sold out",learnMoreLabel:r.learn_more||"Learn more",priceFromLabel:r.price_from_prefix||"From",supplyNoteLabel:r.supply_note||"for a 1 month supply",bundleDefaultCtaLabel:r.bundle_default_cta||"Alles in den Warenkorb",bundleIntroLabel:r.bundle_intro_label||"Bundle & Save",bundleFromSavingsTemplate:r.bundle_from_savings_template||"ab {{amount}} sparen",bundleConfirmLabels:r,bundleConfirmTitle:r.bundle_confirm_title||"Alles hinzufügen"})){if(document.querySelector("[data-yqr-video-hero]")===null){we(t);return}pt(e,()=>we(t))}})}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",Te):Te()})();
